module.exports = __webpack_public_path__ + "img/CreditScan.b8c4ec8c.png";